/**
 * Deixa a fala do Secretário como texto de conversa: sem marcas de formatação
 * (asteriscos, sublinhados, cerquilhas, crases) e sem travessão no meio da
 * frase. Nomes com traço baixo, como @ana_souza, ficam como estão.
 */
export function plainReply(text) {
    return (text
        // Títulos e citações no começo da linha.
        .replace(/^[ \t]*#{1,6}[ \t]+/gm, '')
        .replace(/^[ \t]*>[ \t]?/gm, '')
        // Linhas divisórias (---, ___, ***).
        .replace(/^[ \t]*([-_*])(?:[ \t]*\1){2,}[ \t]*$/gm, '')
        // Marcadores de lista com asterisco ou bolinha viram hífen.
        .replace(/^([ \t]*)[*•][ \t]+/gm, '$1- ')
        // Negrito, itálico e código.
        .replace(/\*\*([^*\n]+)\*\*/g, '$1')
        .replace(/__([^_\n]+)__/g, '$1')
        .replace(/(^|[\s(])\*([^*\n]+)\*(?=[\s).,;:!?]|$)/gm, '$1$2')
        .replace(/(^|[\s(])_([^_\n]+)_(?=[\s).,;:!?]|$)/gm, '$1$2')
        .replace(/`{1,3}([^`\n]*)`{1,3}/g, '$1')
        .replace(/\*\*|__/g, '')
        // Travessão ou dois hífens no meio da frase viram vírgula.
        .replace(/[ \t]*(?:—|--+)[ \t]*/g, ', ')
        .replace(/[ \t]+–[ \t]+/g, ', ')
        .replace(/,[ \t]*,/g, ',')
        .replace(/^, /gm, '')
        .replace(/,[ \t]*([.!?:;])/g, '$1')
        .replace(/,[ \t]*$/gm, '')
        .replace(/\n{3,}/g, '\n\n'));
}
